export function sortedRoleIds(ids: string[]) {
    return [...ids].sort();
}

export function sameRoleIdLists(a: string[], b: string[]) {
    return JSON.stringify(sortedRoleIds(a)) === JSON.stringify(sortedRoleIds(b));
}

type AgentLike = { id?: string; is_system?: unknown; isSystem?: unknown } | null | undefined;

export function isSystemCommandAgent(agent: AgentLike): boolean {
    if (!agent) return false;
    const value = agent.is_system ?? agent.isSystem;
    if (value === true || value === 1) return true;
    if (typeof value === "string" && value.toLowerCase() === "true") return true;
    return false;
}
